

export class UserDetails {
  email: string;
  family_name: string;
  given_name: string;
  picture: string;
  username: string;
  constructor(obj: any) {
    this.email = obj?.email;
    this.family_name = obj?.family_name;
    this.given_name = obj?.given_name;
    this.picture = obj?.picture;
    this.username = obj?.username;
  }
}

class Role {
  name: string;
  display_name: string;
  description: string;
  constructor(obj: any) {
    this.name = obj?.name;
    this.display_name = obj?.display_name;
    this.description = obj?.description;
  }
}

export class ProfileData {
  id: string;
  email: string;
  family_name: string;
  given_name: string;
  picture: string;
  // roles: Role[];
  // isPowerUser: boolean;
  // isClauseCheckAllowed: boolean;
  // isContractReviewAllowed: boolean;

  constructor(obj: any) {
    this.id = obj?.id;
    this.email = obj?.email;
    this.family_name = obj?.family_name;
    this.given_name = obj?.given_name;
    this.picture = obj?.picture;
    // this.roles = obj?.roles?.map((role: any) => new Role(role)) || [];
    // this.isPowerUser =
    //   obj?.roles?.filter((role: any) => role?.name === UserRolesKey.ADMIN)
    //     .length !== 0;
    // this.isClauseCheckAllowed =
    //   this.isPowerUser ||
    //   this.roles?.some(
    //     (role: any) => role?.name === UserRolesKey.CLAUSE_CHECK_USER
    //   );

    // this.isContractReviewAllowed =
    //   this.isPowerUser ||
    //   this.roles?.some(
    //     (role: any) => role?.name === UserRolesKey.REDLINING_USER
    //   );
  }
}
